import styles from "./styles.module.css";
import Image from "@/shared/components/Image/new";
import { EnVivo } from "@/shared/components/enVivo";

const TePuedeInteresar = (props) => {
    const clipping = "3_2_300x200";
    const { 
        title = "Te puede interesar: ",
        limitMd,
        limitSm,
    } = props;

    return (
        <>
            {props.content && props.content.length > 0 && (
                <div className={`${styles["content-parent"]}`}>
                    <h4 className={`${styles["widget-title"]}`}>{title}</h4>
                    <hr className={`${styles['divisor']}`}/>
                    <ul className={`${styles["main-content"]}`}>
                        {props.content.map((element, index) => {
                    const { subtitle, url, id, title, authors, metadata} = element;
                            
                            let hideMd = '';
                            let hideSm = '';
                            
                            if (index + 1 > limitMd) {
                                hideMd = 'hide-md';
                            }

                            if (index + 1 > limitSm) {
                                hideSm = 'hide-sm';
                            }                            

                            return (
                                <li key={index} className={`${styles["block-content"]} ${styles["sponsored"]} ${styles[hideMd]} ${styles[hideSm]}`} >
                                    <a href={url}>
                                        <Image 
                                            element={element} 
                                            clipping={clipping}
                                            width={300}
                                            height={200}
                                            className={`${styles["img"]}`}
                                            />
                                            {metadata?.sponsored && <EnVivo classStyle={styles["badge"]} data-testid='patrocinado' title={'patrocinado'} />}
                                            {metadata && metadata.typeWeb && metadata.typeWeb === "live_blog" && <EnVivo data-testid='envivo'/>}
                                        <h5>{title}</h5>
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </>
    );
};

export default TePuedeInteresar;
